export default "__VITE_ASSET__Bm9lXmtQ__"